import '@rcs/ui/styles.css';
import './styles/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Boot } from './Boot';

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root が見つかりません');
}

createRoot(root).render(
  <StrictMode>
    <Boot />
  </StrictMode>,
);
